import { css, jsx } from '@emotion/react';
import { Animation } from '../../../theme/Animation.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import { Shadows } from '../../../theme/Shadows.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { PDLStyleMap, ServiceIconConfig } from '../ServiceIcon/constants.es.js';

const Styles = labelStyles("ServiceIconShell", {
  root: ({ hasBorder, hasShadow, hasWhiteBackground, size }) => {
    const { borderRadius } = ServiceIconConfig[size];
    const border = hasBorder ? `1px solid var(--zds-stroke-weaker, ${Colors.neutral300})` : `none`;
    const background = hasWhiteBackground ? Colors.white : Colors.neutral100;
    return [
      css`
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--zds-prime-white, ${background});
        border: ${border};
        border-radius: var(
          ${PDLStyleMap[size].borderRadius},
          ${borderRadius}px
        );

        // Note: this is a hack to get around the Img component not
        // allowing css vars for height/width settings in ServiceIcon.tsx
        & > img {
          // This variable is referenced in PDLStyleMap
          --pdl-small-icon-size: calc(var(--zds-size-16) - 2px);

          width: var(
            ${PDLStyleMap[size].iconSize},
            ${ServiceIconConfig[size].iconSize}px
          ) !important;
        }
      `,
      withModifier(`size`, css`
          height: var(${PDLStyleMap[size].width}, ${size}px);
          width: var(${PDLStyleMap[size].width}, ${size}px);
        `),
      hasShadow && withModifier("shadowed", css`
            box-shadow: ${Shadows.elevation5};
            transition-duration: ${Animation.transitionDuration};
            transition-property: box-shadow;
            transition-timing-function: ${Animation.transitionTimingFunction};
          `)
    ];
  }
});
const ServiceIconShell = ({ children, hasBorder = true, hasShadow = false, hasWhiteBackground = false, size }) => {
  return jsx("span", { css: Styles.root({
    hasBorder,
    hasShadow,
    hasWhiteBackground,
    size
  }), "data-zds": true, "data-testid": "ServiceIconShell" }, children);
};

export { ServiceIconShell };
//# sourceMappingURL=ServiceIconShell.es.js.map
